export const routes = {
  home: "/",
  contact: "/contact",
  budgetCalculator: "/budget-calculator",
  about: "/about",
  intermediaries: "/intermediaries",
  keyWorkers: "/key-workers",
  firstTimeBuyers: "/first-time-buyers",
  privacy: "/privacy",
  termsOfUse: "/terms-of-use",
  surveyAndValuationFee: "/survey-and-valuation-fee",
  faqs: "/faqs",
  refer: "/refer",
  howitworks: "/how-it-works",
  press: "/press",
  bipPdf: "/bip-pdf",
  quoteOfferPdf: "/quote-offer-pdf",
  shareBudget: "/share-budget",
  blog: "/blog",
  apply: {
    root: "/apply",
    incomeVerification: "/apply/income-verification",
    success: "/apply/success",
    uploadBankStatements: "/apply/upload-bank-statements",
  },
  landlords: {
    root: "/landlords",
    register: "/landlords/register",
    dealCalculator: "/landlords/deal-calculator",
    aboutUs: "/landlords/about-us",
    howItWorks: "/landlords/how-it-works",
    articles: "/landlords/articles",
  },
  properties: {
    bermondsey: "/properties/bermondsey",
    canningTown: "/properties/canning-town",
    clapham: "/properties/clapham",
    southall: "/properties/southall",
    ealing: "/properties/ealing",
    hayes: "/properties/hayes",
    harrow: "/properties/harrow",
    hendon: "/properties/hendon",
    hanwell: "/properties/hanwell",
    wandsworth: "/properties/wandsworth",
    twickenham: "/properties/twickenham",
  },
  howItWorks: "/how-it-works",
  searchHomes: "/properties",
  calculator: "/#calculator",
  registerInterest: "/register-interest",
  register: "/register",
  customerReviews: "/customer-reviews",
  application: {
    root: "/application",
    personalDetails: "/application/personal-details",
    income: "/application/income",
    expenditure: "/application/expenditure",
    qualifyingCriteria: "/application/qualifying-criteria",
    property: "/application/property",
    setPassword: "/application/set-password",
    incomeVerification: "/application/income-verification",
    contactUs: "/application/contact-us",
  },
  rentalApplication: {
    eligibility: "/register/eligibility",
    applicants: "/register/applicants",
    yourHome: "/register/your-home",
    contactUs: "/register/contact-us",
  },
  dashboard: {
    root: "/dashboard",
    login: "/dashboard/login",
    forgotPassword: "/dashboard/forgot-password",
    newPassword: "/dashboard/forgot-password/new",
    qualifyingCriteria: "/dashboard/qualifying-criteria",
    identityVerification: "/dashboard/identity-verification",
    incomeVerification: "/dashboard/income-verification",
    documents: "/dashboard/documents",
    howToGuides: "/dashboard/how-to-guides",
    referral: "/dashboard/referral",
    referee: "/dashboard/r",
    refereeLink: "/dashboard/r/[referralCode]",
    faq: "/dashboard/faq",
    contact: "/dashboard/contact",
    addApplicant: "/dashboard/add-applicant",
    preferredPropertyDetails: "/dashboard/preferred-property-details",
    manageAccount: "/dashboard/manage-account",
    offer: {
      witness: "/dashboard/offer/witness",
      confirmMoveInDate: "/dashboard/offer/confirm-move-in-date",
      acceptOffer: "/dashboard/offer/accept-offer",
    },
    secondaryApplicant: {
      root: "/dashboard/secondary-applicant",
      personalDetails: "/dashboard/secondary-applicant/personal-details",
      income: "/dashboard/secondary-applicant/income",
      expenditure: "/dashboard/secondary-applicant/expenditure",
      qualifyingCriteria: "/dashboard/secondary-applicant/qualifying-criteria",
      contactUs: "/dashboard/secondary-applicant/contact-us",
    },
    propertyOverview: {
      root: "/dashboard/property-overview/",
      address: "/dashboard/property-overview/address",
      agent: "/dashboard/property-overview/estate-agent",
    },
    propertyDetails: {
      root: "/dashboard/property-details/",
      propertyType: "/dashboard/property-details/property-type",
      leaseType: "/dashboard/property-details/lease-type",
      propertyInformation: "/dashboard/property-details/property-information",
    },
    personalDetails: {
      root: "/dashboard/personal-details/",
      about: "/dashboard/personal-details/about",
      addressHistory: "/dashboard/personal-details/address-history",
    },
    financialDetails: {
      primary: "/dashboard/financial-details/primary",
      other: {
        root: "/dashboard/financial-details/other",
        employer: "/dashboard/financial-details/other/employer",
        soleTrader: "/dashboard/financial-details/other/sole-trader",
        ltd: "/dashboard/financial-details/other/ltd",
        benefits: "/dashboard/financial-details/other/benefits",
        pension: "/dashboard/financial-details/other/pension",
        other: "/dashboard/financial-details/other/other",
      },
    },
    expenditure: {
      root: "/dashboard/expenditure",
      loansAndMortgages: "/dashboard/expenditure/loans-and-mortgages",
      creditAndStoreCards: "/dashboard/expenditure/credit-and-store-cards",
      dependants: "/dashboard/expenditure/dependants",
    },
    yourOffer: "/dashboard/your-offer",
  },
  openBanking: {
    callback: "/open-banking/callback",
  },
  bookViewing: {
    bookPropertyViewing({ slug, id }: { slug: string; id: string }) {
      return `/book-viewing/${slug}/${id}`;
    },
    preferences({ slug, id }: { slug: string; id: string }) {
      return `/book-viewing/${slug}/${id}/preferences`;
    },
    success({ slug, id }: { slug: string; id: string }) {
      return `/book-viewing/${slug}/${id}/success`;
    },
  },
  magicLink: {
    root: "/dashboard/login",
    checkEmail: "/dashboard/magic-link/check-email",
  },
  bookNeighbourhoodViewing: {
    bookNeighbourhoodViewing({ slug }: { slug: string }) {
      return `/book-viewing/${slug}`;
    },
    preferences({ slug }: { slug: string }) {
      return `/book-viewing/${slug}/preferences`;
    },
    success({ slug }: { slug: string }) {
      return `/book-viewing/${slug}/success`;
    },
    ineligible({ slug }: { slug: string }) {
      return `/book-viewing/${slug}/ineligible`;
    },
  },
};
